import React from 'react';
import {withTranslation} from "react-i18next";
import ButtonComponent from "./ButtonComponent";
import LoadingComponent from "./LoadingComponent";

class ClaimRewardComponent extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            selectedValue: 1
        }
    }

    incr(){
        if(this.state.selectedValue < this.props.maxAmount){
            let newValue = this.state.selectedValue + 1;
            this.setState({selectedValue : newValue});
        }
    }

    decr(){
        if(this.state.selectedValue > 1){
            let newValue = this.state.selectedValue - 1;
            this.setState({selectedValue : newValue});
        }
    }

    setVal(newVal){
        newVal = parseInt(newVal);
        if(newVal >= 1 && newVal <= this.props.maxAmount)
            this.setState({selectedValue: newVal});
    }


    render(){
        const {t} = this.props;
        return  <div className="full-height">

                    {this.props.maxAmount>1 && <div>
                        <div className="amountTitle">{t('reward.amount')}</div>
                        <div className="number-input">
                            <button onClick={() => this.decr()} className="spinner-button">-</button>
                            <input className="amount-input" type="number" min={1} max={this.props.maxAmount} value={this.state.selectedValue} onChange={(e) => this.setVal(e.currentTarget.value)} />
                            <button onClick={() => this.incr()} className="spinner-button">+</button>
                        </div>
                    </div>}
                    {this.props.showRewardClaimedDescription ?
                        this.props.rewardClaimedDescription ?
                            <p dangerouslySetInnerHTML={{__html: this.props.rewardClaimedDescription}}/>
                            : <LoadingComponent/>
                        : null}

                        {this.props.showClaimButton ?
                            this.props.integratorType === "PDF_WITH_CODE" ?
                                <div data-tms-event="card-click-impression" data-tms-card-zone="myReward – deal detail" data-tms-card-name="Confirm">
                                    <ButtonComponent
                                        onButtonClick={() => this.props.claimReward(this.props.friendlyName, this.state.selectedValue)}
                                        textKey="reward.claim-now" className="confirm-btn"/>
                                </div> :
                                <div data-tms-event="card-click-impression" data-tms-card-zone="myReward – deal detail" data-tms-card-name="Confirm">
                                    <a href={this.props.url} target="_blank" rel="noopener noreferrer">
                                        <ButtonComponent textKey="reward.claim-now" className="confirm-btn"
                                                         onButtonClick={() => this.props.claimRewardByRedirect()}/>
                                    </a>
                                </div>
                            : null
                        }
                </div>
        }

}

export default withTranslation() (ClaimRewardComponent)